import { components as SelectComponents } from 'react-select';
import { type ComponentType } from 'react';
import { type OptionProps } from 'react-select/lib/components/Option';
import { type ControlProps } from 'react-select/lib/components/Control';

import SelectAll from '../../SelectAll';

export type CheckboxSelectOption = {
  value: string;
  label: string;
};

type CheckboxMultiSelectFilterProps = {
  options: CheckboxSelectOption[];
  value: string[];
  onChange: (values: string[]) => void;
  menuWidth?: number;
};

const Option: ComponentType<OptionProps<CheckboxSelectOption[]>> = props => (
  <div>
    <SelectComponents.Option {...props}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          style={{ width: '20px', marginRight: '10px' }}
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />
        <label style={{ width: '100%', textWrap: 'wrap' }}>{props.label}</label>
      </div>
    </SelectComponents.Option>
  </div>
);

const Control: ComponentType<ControlProps<CheckboxSelectOption[]>> = props => {
  const { innerProps } = props;
  const hasSelectedValues =
    Array.isArray(props.getValue?.()) && (props.getValue()?.length ?? 0) > 0;
  const style = {
    marginBottom: '2px',
    ...(hasSelectedValues ? {} : { height: '20px' }),
  };

  return (
    <SelectComponents.Control
      {...props}
      innerProps={{
        ...innerProps,
        // @ts-expect-error react-select types do not cover inline styles on innerProps
        style,
      }}
    />
  );
};

const CheckboxMultiSelectFilter = ({
  options,
  value,
  onChange,
  menuWidth,
}: CheckboxMultiSelectFilterProps) => {
  const selectedOptions = options.filter(option =>
    value.includes(option.value)
  );

  return (
    <SelectAll
      options={options}
      mapBy="label"
      trackBy="value"
      optionSelected={selectedOptions}
      allowSelectAll={false}
      menuWidth={menuWidth}
      components={{ Option, Control }}
      handleChange={(selected: CheckboxSelectOption[] | null) =>
        onChange(
          (selected ?? []).map(({ value: selectedValue }) => selectedValue)
        )
      }
    />
  );
};

export default CheckboxMultiSelectFilter;
